import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';
import { trackFormSubmit, trackButtonClick } from '../../../utils/googleAnalyticsService';

const NewsletterSignup = () => {
  const navigate = useNavigate();
  const [email, setEmail] = React.useState('');

  const handleStartPlanning = () => {
    navigate('/ai-trip-planning-interface');
  };

  const handleSubmit = async (e) => {
    e?.preventDefault();
    
    // Track newsletter signup
    trackFormSubmit('newsletter_signup', 'newsletter', {
      has_email: !!email,
      source: 'landing_page',
    });
    
    trackButtonClick('newsletter_subscribe', 'Subscribe to Newsletter', {
      email_domain: email?.split('@')?.[1],
    });

    // ... keep existing newsletter signup code ...
  };

  return (
    <section className="lg:py-12 bg-primary/5 py-3">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <Button
          variant="default"
          size="lg"
          onClick={handleStartPlanning}
          iconName="ArrowRight"
          iconPosition="right"
          className="mx-auto">

          Start Planning Your Trip
        </Button>
      </div>
    </section>);

};

export default NewsletterSignup;